export function hasWindow(): boolean {
	try {
		const x = window;
		return Boolean(x);
	} catch (e) {
		return false;
	}
}

export function getGlobalContext(): Window & typeof globalThis {
	if (hasWindow()) {
		return window;
	}
	// eslint-disable-next-line
	return self;
}
